interface Condition {
  condition: boolean;
  classe: string;
}
export const classNames = (
  classes: string[],
  conditions?: Condition[] | Condition
) => {
  // pour passer plusieurs conditions
  if (conditions && Array.isArray(conditions)) {
    conditions.forEach(c => {
      if (c.condition) classes.push(c.classe);
    });
  }
  // pour passer une seule condition
  if (conditions && !Array.isArray(conditions) && conditions.condition)
    classes.push(conditions.classe);
  return classes.join(' ');
};
